import { firestore } from '@src/api/Firebase/Firebase';
import { collection } from 'firebase/firestore';

export interface ProductCategory {
    id?: string;
    priority: number;
    name: string;
}

export const PRODUCT_CATEGORIES_COLLECTION = 'product-categories';

export const productCategoriesRef = collection(firestore, PRODUCT_CATEGORIES_COLLECTION);
